import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import CurrencyValue from 'ui-component/CurrencyValue';
import CurrencyValueFlex from 'ui-component/CurrencyValueFlex';
import StatusBadge from 'ui-component/StatusBadge';
import { CommonDateOnlyFormat } from 'helpers/common.helper';
import usePermissions from 'hooks/usePermissions';
import useIsMobile from 'utils/isMobileUtils';

const QoutationComponent = ({ details, viewedBy = 'ADMIN' }) => {
    const [allPermissions, hasEveryPermission] = usePermissions();
    const history = useNavigate();
    const isMobile = useIsMobile();

    const handleOpenNewTab = (pageModule, id, ref) => {
        let url = '';
        if (pageModule == 'products') {
            url = viewedBy === 'ADMIN' ? `/products/${id}` : `/client/products/${id}`;
        } else if (pageModule == 'contacts') {
            url = `/contacts/${id}`;
        } else if (pageModule == 'purchase_orders') {
            url = `/purchasing/view/${id}`;
        } else if (pageModule == 'sales_orders') {
            url = viewedBy === 'ADMIN' ? `/sales/sales-orders/${id}?ref=${ref}` : `/client/sales-orders/${id}?ref=${ref}`;
        } else if (pageModule == 'invoices') {
            url = viewedBy === 'ADMIN' ? `/sales/invoices/${id}?ref=${ref}` : `/client/invoices/${id}?ref=${ref}`;
        } else if (pageModule == 'quotations') {
            url = viewedBy === 'ADMIN' ? `/sales/quotations/${id}?ref=${ref}` : `/client/quotations/${id}?ref=${ref}`;
        }
        if (url) {
            history(url);
        }
    };

    return (
        !isMobile ? (
            <div style={{ padding: '0px 20px 20px 16px' }}>
                <div className="row mb10">
                    <div className="col-12">
                        <h2 className="d-flex font600" style={{ fontSize: '18px' }}>Quotation</h2>
                    </div>
                </div>
                <div className="row">
                    {
                        viewedBy === 'ADMIN' ? (
                            <>
                                <div className="col-md-2 font600">Quote #</div>
                                <div className="col-md-4 font600">Customer</div>
                                <div className="col-md-2 font600">Date</div>
                                <div className="col-md-2 font600">Status</div>
                                <div className="col-md-2 font600">Total</div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-4 font600">Quote #</div>
                                <div className="col-md-4 font600">Date</div>
                                {/* <div className="col-md-3 font600">Total</div> */}
                                <div className="col-md-4 font600">Status</div>

                            </>
                        )
                    }
                </div>
                <hr className="mt8 mb8" />
                <div className="row">
                    {
                        viewedBy === 'ADMIN' ? (
                            <>
                                <div className="col-md-2 d-flex align-items-center">
                                    <div
                                        className={`${hasEveryPermission(['View Estimation Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (hasEveryPermission(['View Estimation Details (Page)'])) {
                                                handleOpenNewTab('quotations', details?.qoutation?.id, details?.qoutation?.ref)
                                            }
                                        }}
                                    >
                                        {details?.qoutation?.estimation_number}
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <div
                                        className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                        onClick={() => {
                                            if (hasEveryPermission(['View Contact Details (Page)'])) {
                                                handleOpenNewTab('contacts', details?.qoutation?.customer?.id, details?.qoutation?.ref)
                                            }
                                        }}
                                    >
                                        {details?.qoutation?.customer?.name}
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center">{moment(details?.qoutation?.date).format(CommonDateOnlyFormat)}</div>
                                <div className="col-md-2 "><div style={{ width: '90px' }}><StatusBadge itemStatus={details?.qoutation?.status} /></div></div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <CurrencyValueFlex
                                        currencyObject={details?.qoutation?.converted_currency_total}
                                        defaultCurrency={details?.qoutation?.currency}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-4 d-flex align-items-center">
                                    <div
                                        className={`text-primary cursor-pointer`}
                                        onClick={() => {
                                            handleOpenNewTab('quotations', details?.qoutation?.estimation_number, details?.qoutation?.ref)
                                        }}
                                    >
                                        {details?.qoutation?.estimation_number}
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">{moment(details?.qoutation?.date).format(CommonDateOnlyFormat)}</div>
                               
                                <div className="col-md-4 "><div style={{ width: '90px' }}><StatusBadge itemStatus={details?.qoutation?.status} /></div></div>
                            </>
                        )
                    }
                </div>
                <hr className="mt8 mb8" />
            </div>
        ) : (
            // --- MOBILE VERSION (copied from SalesOrder QoutationComponent) ---
            <div
                style={{ display: 'flex', flexDirection: 'column' }}
                onClick={() => {
                    if (viewedBy === 'ADMIN') {
                        handleOpenNewTab('quotations', details?.qoutation?.id, details?.qoutation?.ref);
                    } else {
                        handleOpenNewTab('quotations', details?.qoutation?.estimation_number, details?.qoutation?.ref);
                    }
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                    <h2 className="d-flex font500" style={{ fontSize: '17px', marginBottom: 0 }}>
                        Quotation
                    </h2>
                    <div style={{ width: '90px' }}>
                        <StatusBadge itemStatus={details?.qoutation?.status} />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 5, alignItems: 'center', fontWeight: 500, fontSize: 13 }}>
                        Quote #:
                        <span
                            className={`text-primary cursor-pointer`}
                        
                        >
                            {details?.qoutation?.estimation_number}
                        </span>
                    </div>
                    <div>{moment(details?.qoutation?.date).format(CommonDateOnlyFormat)}</div>
                </div>
                
                {
                    viewedBy === 'ADMIN' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 500, fontSize: 13 }}>
                                <div
                                    className={`${hasEveryPermission(['View Contact Details (Page)']) ? 'text-primary cursor-pointer' : ''}`}
                                    
                                    style={{ fontWeight: 500 }}
                                >
                                    {details?.qoutation?.customer?.name}
                                </div>
                                <div style={{ fontWeight: 500 }}>
                                    <CurrencyValue
                                        currencyObject={details?.qoutation?.converted_currency_total}
                                        defaultCurrency={details?.qoutation?.currency}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
        )
    );
};

export default QoutationComponent;
